export default __webpack_public_path__ + "static/security-image-c12883446106b19e4ee4f0a392a2bf34.png";